import BaseNode from '@/types/BaseNode';
import Component from 'vue-class-component';
import {Prop, Vue} from 'vue-property-decorator';
import { SelectionTypeEnum } from '../Generics/GenericTable/GenericTableEnums';
import { Row } from '../Generics/GenericTable/GenericTableRow';


@Component
export class SearchDisplayer extends Vue {

    /** Variant de couleur à utiliser sur le tableau de bord */
    @Prop({ default: "primary" })
    public Variant!: string;

    /** Liste de résultat à afficher */
    @Prop({ default: [] })
    protected Results!: Array<BaseNode>;

    /**
     * Propriété de la pagination
     */
    protected currentPage: number = 1;
    protected itemPerPage: number = 6;

    /**
     * Enumération sur le type de sélection
     */
    protected selectionTypeEnum = SelectionTypeEnum;
    
    /**
     * Event Selection ligne
     */
    protected OnRowSelected(row: Row) {
        this.$emit("OnRowSelected", row);
    }
}